import { RotateCcw as Restore } from 'lucide-react';
import React from 'react';
import { ActionButton } from './ActionButton';

interface RestoreActionProps {
  onRestore: () => void;
  actionLoading:
    | 'retry'
    | 'delete'
    | 'save'
    | 'lock'
    | 'unlock'
    | 'restore'
    | 'zurueckstellen'
    | null;
}

export const RestoreAction: React.FC<RestoreActionProps> = ({
  onRestore,
  actionLoading,
}) => {
  return (
    <ActionButton
      onClick={onRestore}
      disabled={actionLoading !== null}
      loading={actionLoading === 'restore'}
      loadingText="Wird wiederhergestellt..."
      normalText="Wiederherstellen"
      icon={Restore}
      className="bg-green-500 hover:bg-green-600 text-white shadow-sm"
    />
  );
};
